import { env } from '@repo/env';

export const EMBEDS_URL =
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod'
    ? 'https://embeds.nerdwallet.com'
    : 'https://embeds.nerdwallet.biz';
